<template>
    <section>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

        <!--列表-->
        <el-table :data="members"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table"
                  class="custom-tbl"
                  style="width: 100%">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" width="80"> </el-table-column>
            <el-table-column prop="Title" label="标题" width="" sortable>
            </el-table-column>
            <el-table-column prop="LinkTypeName" label="链接类型" width="" sortable>
            </el-table-column>
            <el-table-column prop="ShowTypeName" label="显示类型" width="" sortable>
            </el-table-column>
            <el-table-column label="图片" prop="ImgUrl" align="center" width="100px">
                <template slot-scope="scope" v-if="scope.row.ImgUrl!=null&&scope.row.ImgUrl!=''&&scope.row.ImgUrl.indexOf('.')>0">
                    <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                              :src="`${scope.row.ImgUrl}`">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="OrderNumber" label="排序序号" width="" sortable>
            </el-table-column>

            <el-table-column prop="Createdate"
                             label="添加时间"
                             :formatter="formatBirth"
                             width=""
                             sortable>
            </el-table-column>
            <el-table-column prop="Status" label="状态" width="" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.Status == 0 ? 'success' : 'danger'"
                            disable-transitions>
                        {{ scope.row.Status == 0 ? "激活" : "冻结" }}
                    </el-tag>
                </template>
            </el-table-column>
            <!--<el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>-->
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float: right">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm"
                     label-width="80px"
                     :rules="editFormRules"
                     ref="editForm">
                <el-form-item label="标题" prop="Title">
                    <el-input v-model="editForm.Title" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序序号" prop="OrderNumber">
                    <el-input-number v-model="editForm.OrderNumber" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="显示位置" prop="ShowType">
                    <el-select v-model="editForm.ShowType" placeholder="请选择显示位置">
                        <el-option :key="0" :label="'未选择显示位置'" :value="0"></el-option>
                        <el-option v-for="(item,index) in allShowType"
                                   :key="'ShowType'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接类型" prop="LinkType">
                    <el-select v-model="editForm.LinkType" placeholder="请选择链接类型" @change="handleChange">
                        <el-option :key="0" :label="'未选择链接类型'" :value="-1"></el-option>
                        <el-option v-for="(item,index) in allLinkType"
                                   :key="'LinkType'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址" prop="Url" v-if="IsShowUrl">
                    <el-select v-model="editForm.Url" placeholder="请选择链接地址" filterable>
                        <el-option :key="0" :label="'未选择链接地址'" :value="-1"></el-option>
                        <el-option v-for="(item,index) in allUrl"
                                   :key="'Url'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="editForm.Status">
                        <el-radio class="radio" :label="0">激活</el-radio>
                        <el-radio class="radio" :label="1">冻结</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="图片" prop="ImgUrl">
                    <el-upload action=""
                               accept="image/jpeg"
                               :before-upload="beforeUploadPicture"
                               :show-file-list="false"
                               :data="extraData()"
                               :http-request="handleHttpRequest">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <span style="margin-left:50px;" v-if="IsShowImgUrl"><img :src="this.EditImgUrlUrl" style="width:100px; height:100px;" /></span>
                    </el-upload>
                </el-form-item>
                <el-form-item label="图文说明" prop="Remark" style="display:none;">
                    <div class="edit_container">
                        <quill-editor v-model="editForm.Remark"
                                      ref="myQuillEditor"
                                      class="editer"
                                      :options="editorOption"
                                      @ready="onEditorReady($event)"></quill-editor>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="editSubmit"
                           :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="80px"
                     :rules="addFormRules"
                     ref="addForm">

                <el-form-item label="标题" prop="Title">
                    <el-input v-model="addForm.Title" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序序号" prop="OrderNumber">
                    <el-input-number v-model="addForm.OrderNumber" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="显示位置" prop="ShowType">
                    <el-select v-model="addForm.ShowType" placeholder="请选择显示位置">
                        <el-option :key="0" :label="'未选择显示位置'" :value="0"></el-option>
                        <el-option v-for="(item,index) in allShowType"
                                   :key="'ShowType'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接类型" prop="LinkType">
                    <el-select v-model="addForm.LinkType" placeholder="请选择链接类型" @change="handleChange">
                        <el-option :key="0" :label="'未选择链接类型'" :value="-1"></el-option>
                        <el-option v-for="(item,index) in allLinkType"
                                   :key="'LinkType'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址" prop="Url" v-if="IsShowUrl">
                    <el-select v-model="addForm.Url" placeholder="请选择链接地址" filterable>
                        <el-option :key="0" :label="'未选择链接地址'" :value="-1"></el-option>
                        <el-option v-for="(item,index) in allUrl"
                                   :key="'Url'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="addForm.Status">
                        <el-radio class="radio" :label="0">激活</el-radio>
                        <el-radio class="radio" :label="1">冻结</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="图片" prop="ImgUrl">
                    <el-upload action=""
                               accept="image/jpeg"
                               :before-upload="beforeUploadPicture"
                               :show-file-list="false"
                               :data="extraData()"
                               :http-request="handleHttpRequest">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <span style="margin-left:50px;" v-if="IsShowImgUrl"><img :src="this.EditImgUrlUrl" style="width:100px; height:100px;" /></span>
                    </el-upload>
                </el-form-item>
                <el-form-item label="图文说明" prop="Remark" style="display:none;">
                    <div class="edit_container">
                        <quill-editor v-model="addForm.Remark"
                                      ref="myQuillEditor"
                                      class="editer"
                                      :options="editorOption"
                                      @ready="onEditorReady($event)"></quill-editor>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>



        <!--// 隐藏图片上传表单-->
        <el-upload class="avataruploaderTip"
                   ref="uploadtip"
                   :limit="999"
                   action="#"
                   :show-file-list="false"
                   :http-request="uploadImgTip">
        </el-upload>
        <!--// 视频上传弹出框-->
        <el-dialog title="视频上传"
                   :visible.sync="videoFlag"
                   :close-on-click-modal="false"
                   class="editerV"
                   width="500px">
            <div class="editerVideo">
                <div class="editerVideo_title">
                    <div :class="['editerVideo_title_item',videoTab.tabUrl?'editerVideo_title_act':''] " @click="onVideoTab(1)">添加链接</div>
                    <div :class="['editerVideo_title_item',videoTab.tabUpd?'editerVideo_title_act':''] " @click="onVideoTab(2)">上传视频</div>
                </div>
                <div class="editerVideo_main">
                    <div class="editerVideo_main_url" v-if="videoTab.tabUrl">
                        <div>视频地址：</div>
                        <el-input size="small" v-model="videoUrl" style="width:300px"></el-input>
                        <el-button type="primary" style=" margin-left:10px;  height:30px" @click="upVideoUrl" size="small">添加</el-button>
                    </div>
                    <div v-if="videoTab.tabUpd">
                        <div v-if="videoProgress" class="videoProgress">视频上传中，请耐心等待！</div>
                        <el-upload v-else
                                   class="avatar-uploader_video"
                                   :limit=1
                                   action="#"
                                   :show-file-list="false"
                                   :http-request="uploadVideoTip">
                            <i class="el-icon-plus avatar-uploader-videoiocn"></i>
                        </el-upload>

                    </div>
                </div>
            </div>
        </el-dialog>
        <!----上传文件--->
        <el-upload class="uploadFile"
                   action="#"
                   name="file"
                   :show-file-list="false"
                   :http-request="uploadFile"></el-upload>



    </section>
</template>

<script>
    import util from "../../../util/date";
    import {
        removeAdvertisement,
        uploadArticleFiles,
        editAdvertisement,
        addAdvertisement,
        getAdvertisement,
        getAllCoupon,
        getAllBlogArticle,
        getAllRecharge
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    import Toolbar from "../../components/Toolbar";
    /*import global from '../../components/Global'//引用全局模块*/
    import { quillEditor, Quill } from "vue-quill-editor"; //调用编辑器
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";

    export default {
        components: { Toolbar, quillEditor },
        data() {
            return {
                filters: {
                    name: "",
                },
                members: [],
                options: [],
                total: 0,
                buttonList: [],
                currentRow: null,
                page: 1,
                listLoading: false,

                IsShowImgUrl: false,
                EditImgUrl: "",
                EditImgUrlUrl: "",

                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    Title: [
                        { required: true, message: "请输入标题", trigger: "blur" },
                    ],
                },
                //编辑界面数据
                editForm: {
                    Title: "",
                    Url: "-1",
                    Remark: "",
                    ImgUrl: "",
                    ShowType: 0,
                    OrderNumber: 0,
                    Status: 0,
                    LinkType: -1,
                },

                isResouceShow: 0,
                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    Title: [
                        { required: true, message: "请输入标题", trigger: "blur" },
                    ],
                },
                //新增界面数据
                addForm: {
                    Title: "",
                    Url: "",
                    Remark: "",
                    ImgUrl: "",
                    ShowType: 0,
                    OrderNumber: 0,
                    Status: 0,
                    LinkType: -1,
                },
                //allLinkType: [{ Name: '商品', Value: '1' }, { Name: '商品分类', Value: '2' }, { Name: '文章', Value: '3' }, { Name: '订单列表', Value: '4' }, { Name: '第三方链接', Value: '0' }],//链接类型
                allLinkType: [{ Name: '优惠券类型', Value: '1' }, { Name: '充值类型', Value: '2' }, { Name: '文章', Value: '3' }, { Name: '订单列表', Value: '4' }],//链接类型
                allShowType: [{ Name: '首页Banner', Value: '1' }],
                allUrl: [],
                allProductTypes: [],
                allProducts: [],
                allBlogArticle: [],
                IsShowUrl: true,
                //配置上传视频图片start

                // 配置项
                editorOption: {
                    modules: {
                        //imageDrop: true,      //图片拖拽
                        //imageResize: {          //放大缩小
                        //    displaySize: true
                        //},
                        toolbar: {
                            container: [
                                //['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
                                //[{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
                                //[{ 'list': 'ordered' }, { 'list': 'bullet' }], //列表
                                //[{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
                                //[{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
                                //[{ 'direction': 'rtl' }], // 文本方向
                                //['clean'], //清除字体样式
                                //['image', 'video'] //上传图片、上传视频

                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["blockquote", "code-block"], // 引用  代码块
                                [{ 'header': 1 }, { 'header': 2 }], // 1、2 级标题
                                [{ 'list': "ordered" }, { 'list': "bullet" }], // 有序、无序列表
                                [{ 'script': "sub" }, { 'script': "super" }], // 上标/下标
                                [{ 'indent': "-1" }, { 'indent': "+1" }], // 缩进
                                // [{'direction': 'rtl'}],                         // 文本方向
                                [{ 'size': ["small", false, "large", "huge"] }], // 字体大小
                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 标题
                                [{ 'color': [] }, { 'background': [] }], // 字体颜色、字体背景颜色
                                [{ 'font': [] }], // 字体种类
                                [{ 'align': [] }], // 对齐方式
                                ["clean"], // 清除文本格式
                                ["link", "image", "video", "upload"] // 链接、图片、视频、文件


                            ],
                            handlers: {
                                'video': (val) => {
                                    // 覆盖默认的上传视频
                                    this.onVideo();
                                },
                                'image': (value) => {
                                    // 覆盖默认的图片上传
                                    // 获取光标所在的位置
                                    var range = this.$refs.myQuillEditor.quill.getSelection();
                                    if (range == null) {
                                        this.indexVideo = 0;
                                    } else {
                                        this.indexVideo = range.index;
                                    }
                                    // 点击隐藏的上传表单
                                    if (value) {
                                        document.querySelector('.avataruploaderTip input').click();
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                },
                                'upload': (val) => {
                                    // 点击隐藏的上传表单
                                    if (val) {
                                        document.querySelector('.uploadFile input').click();
                                    }
                                },
                            }
                        }
                    },
                    placeholder: '请输入',
                    readyOnly: false, //是否只读
                    theme: 'snow', //主题 snow/bubble
                    syntax: true, //语法检测
                },
                // 相关变量
                indexVideo: 0,
                videoUrl: '',
                videoTab: {
                    tabUrl: true,
                    tabUpd: false
                },
                videoProgress: false,
                videoFlag: false,
                //配置上传视频图片end
            };
        },
        methods: {
            onEditorReady(editor) { },
            dialogCheck(selection, row) {
                this.currentRow = null;
                this.$refs.table.clearSelection();
                if (selection.length === 0) {
                    return;
                }
                if (row) {
                    this.selectCurrentRow(row);
                }
            },
            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            ////性别显示转换
            //formatSex: function (row, column) {
            //  return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
            //},
            formatBirth: function (row, column) {
                return !row.Createdate || row.Createdate == ""
                    ? ""
                    : util.formatDate.format(new Date(row.Createdate), "yyyy-MM-dd");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            //获取用户列表
            handleQuery() {
                let para = {
                    page: this.page,
                    key: this.filters.name,
                    //ShowType: 1,
                };
                this.listLoading = true;

                //NProgress.start();
                getAdvertisement(para).then((res) => {

                    var that = this;
                    this.total = res.data.response.dataCount;
                    //this.members = res.data.response.data;
                    var types = res.data.response.data;
                    for (var i = 0; i < types.length; i++) {

                        var imgUrl = types[i].ImgUrl;
                        if (imgUrl != null && imgUrl != "") {
                            imgUrl = window.server.PictureDemain + imgUrl;
                        }
                        types[i].ImgUrl = imgUrl;
                        console.log(imgUrl);

                        //var ShowTypeName = "";
                        //var ShowType = types[i].ShowType;
                        //if (ShowType > 0) {
                        //    for (var i = 0; i < this.allShowType.length; i++) {
                        //        if (this.allShowType[i].Value == ShowType) {
                        //            ShowTypeName = this.allShowType[i].Name;
                        //            break;
                        //        }
                        //    }
                        //}
                        //console.log("ShowTypeName=" + ShowTypeName);
                        //this.$set(types[i], "ShowTypeName", ShowTypeName);
                        ////types[i].ShowTypeName = ShowTypeName;

                        //var LinkTypeName = "";
                        //var LinkType = types[i].LinkType;
                        //if (LinkType >= 0) {
                        //    for (var i = 0; i < this.allLinkType.length; i++) {
                        //        if (this.allLinkType[i].Value == LinkType) {
                        //            LinkTypeName = this.allLinkType[i].Name;
                        //            break;
                        //        }
                        //    }
                        //}
                        //console.log("LinkTypeName=" + LinkTypeName);
                        ////this.$set(types[i], "LinkTypeName", LinkTypeName);
                        ////types[i].LinkTypeName = LinkTypeName;
                    }
                    this.members = types;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //删除
            handleDel() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要删除的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeAdvertisement(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }

                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit() {
                let row = this.currentRow;
                this.options = [];
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.IsShowUrl = true;
                if (row.LinkType == 4) {
                    this.IsShowUrl = false;
                }

                var that = this

                that.editForm.ShowType = row.ShowType.toString();
                that.editForm.LinkType = row.LinkType.toString();
                if (row.LinkType != 4) {
                    this.handleChange(row.LinkType);
                    that.editForm.Url = parseInt(row.Url);
                }

                this.IsShowImgUrl = false;
                this.EditImgUrl = "";
                this.EditImgUrlUrl = "";

                if (row.ImgUrl != null && row.ImgUrl != "" && row.ImgUrl.indexOf('.') > 0) {
                    this.IsShowImgUrl = true;
                    this.EditImgUrl = row.ImgUrl.replace(window.server.PictureDemain, '');
                    this.EditImgUrlUrl = row.ImgUrl;
                }
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                this.options = [];
                this.addForm = {
                    Title: "",
                    Url: "",
                    Remark: "",
                    ImgUrl: "",
                    ShowType: 0,
                    OrderNumber: 0,
                    Status: 0,
                    LinkType: -1,
                };
                this.IsShowUrl = true;
                this.IsShowImgUrl = false;
                this.EditImgUrl = "";
                this.EditImgUrlUrl = "";
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);

                            //para.birth =
                            //  !para.birth || para.birth == ""
                            //    ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                            //    : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                            /*para.DepartmentId = para.Dids.pop();*/

                            para.ImgUrl = this.EditImgUrl;

                            if (para.ImgUrl == null || para.ImgUrl == "") {
                                this.$message({
                                    message: "请上传图片！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.ShowType == null || para.ShowType == "" || para.ShowType <= 0) {
                                this.$message({
                                    message: "请选择显示位置！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.LinkType == null || para.LinkType == "" || Number(para.LinkType) < 0) {
                                this.$message({
                                    message: "请选择链接类型！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.LinkType != 4 && (para.Url == null || para.Url == "" || Number(para.Url) <= 0)) {
                                this.$message({
                                    message: "请选择链接地址！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.LinkType == 4) {
                                para.Url = 0;
                            }
                            //para.ShowType = 1;
                            editAdvertisement(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.options = [];
                                    this.editFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    this.editLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            //para.birth =
                            //  !para.birth || para.birth == ""
                            //    ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                            //    : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                            //para.DepartmentId = para.Dids.pop();

                            para.ImgUrl = this.EditImgUrl;

                            if (para.ImgUrl == null || para.ImgUrl == "") {
                                this.$message({
                                    message: "请上传图片！",
                                    type: "error"
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.ShowType == null || para.ShowType == "" || para.ShowType <= 0) {
                                this.$message({
                                    message: "请选择显示位置！",
                                    type: "error"
                                });
                                this.addLoading = false;
                                return;
                            }
                            //if (para.LinkType == null || para.LinkType == "" || Number(para.LinkType) <= 0) {
                            //    this.$message({
                            //        message: "请选择链接类型！",
                            //        type: "error"
                            //    });
                            //    this.addLoading = false;
                            //    return;
                            //}
                            //if (para.LinkType != 4 && (para.Url == null || para.Url == "" || Number(para.Url) <= 0)) {
                            //    this.$message({
                            //        message: "请选择链接地址！",
                            //        type: "error"
                            //    });
                            //    this.addLoading = false;
                            //    return;
                            //} if (para.LinkType == 4) {
                            //    para.Url = 0;
                            //}
                            //para.ShowType = 1;
                            addAdvertisement(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }

                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.options = [];
                                    this.addFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    this.addLoading = false;
                                }
                            });
                        });
                    }
                });
            },



            //上传文件start

            extraData() {
                return {
                    //"name": this.form.name,
                    //"version": this.form.version,
                    //"type": this.form.type
                }
            },

            handleHttpRequest(fileDatas) {
                var para = new FormData();
                //for (let prop in fileDatas.data) {
                //    fd.append(prop, fileDatas.data[prop]);
                //}
                //para.append("fileType", "EquipPicture");
                para.append("file", fileDatas.file);

                //let config = {
                //    headers: {
                //        'Content-Type': 'multipart/form-data'
                //    }
                //}

                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        this.addLoading = false;
                        //NProgress.done();
                        this.$message({
                            message: res.data.msg,
                            type: "success"
                        });
                        this.IsShowImgUrl = true;
                        this.EditImgUrl = res.data.response;
                        this.EditImgUrlUrl = window.server.PictureDemain + res.data.response;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                        this.addLoading = false;
                    }
                });
            },
            beforeUploadPicture(file) {
                //if (this.form.name == null || this.form.name === "") {
                //    this.$message.error('请填写名称');
                //    return false;
                //}
                //if (this.form.version == null || this.form.version === "") {
                //    this.$message.error('请填写版本号');
                //    return false;
                //}
                //if (this.form.type == null || this.form.type === "") {
                //    this.$message.error('请填写类型');
                //    return false;
                //}
                this.addLoading = true;
                const imgType = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!imgType) {
                    this.$message({
                        message: "上传图片只能是 JPG和png 格式!",
                        type: "warning"
                    });
                    this.addLoading = false;
                    return false;
                }
                if (file.size >= 5242880) {
                    this.$message({
                        message: "图片不能大于5M",
                        type: "warning"
                    });
                    this.addLoading = false;
                    return false;
                }
                return true;
            },
            //上传文件end


            // 富文本相关
            onVideo() {
                this.videoFlag = true;
                //当编辑器中没有输入文本时，这里获取到的 range 为 null   获取光标位置
                var range = this.$refs.myQuillEditor.quill.getSelection();
                if (range == null) {
                    this.indexVideo = 0;
                } else {
                    this.indexVideo = range.index;
                }
            },
            onVideoTab(val) {  // 链接与视频上传 tab切换
                if (val == 1) {
                    this.videoTab.tabUrl = true;
                    this.videoTab.tabUpd = false;
                } else {
                    this.videoTab.tabUpd = true;
                    this.videoTab.tabUrl = false;
                }
            },
            //上传视频
            uploadVideoTip(param) {
                //const formData = new FormData()
                //formData.append('file', param.file)
                //this.videoProgress = true;
                //fetchUploadVideo(formData).then(response => {
                //    this.videoForm.showVideoPath = response.videoUrl;
                //    // 获取富文本
                //    let quill = this.$refs.myQuillEditor.quill
                //    // 在光标所在位置 插入视频
                //    quill.insertEmbed(this.indexVideo, 'video', this.videoForm.showVideoPath)
                //    quill.setSelection(this.indexVideo + 1)
                //    this.videoProgress = false;
                //    this.videoFlag = false;
                //});
                this.videoProgress = true;
                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {

                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        //this.videoForm.showVideoPath = res.data.response;
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;
                        // 在光标所在位置 插入视频
                        quill.insertEmbed(this.indexVideo, 'video', url);
                        quill.setSelection(this.indexVideo + 1);
                        this.videoProgress = false;
                        this.videoFlag = false;
                    } else {
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "error"
                        //});
                        //this.addLoading = false;
                        this.videoProgress = false;
                    }
                });

            },
            // 上传图片链接
            upVideoUrl() {
                if (this.videoUrl) {
                    let quill = this.$refs.myQuillEditor.quill
                    quill.insertEmbed(this.indexVideo, 'video', this.videoUrl)
                    quill.setSelection(this.indexVideo + 1)
                    this.videoFlag = false;
                } else {
                    this.$message({
                        message: '请填写视频链接',
                        type: 'warning'
                    });
                }
            },
            // 图片上传
            uploadImgTip(param) {
                //const formData = new FormData()
                //formData.append('file', param.file)
                //fetchImg(formData).then(response => {
                //    let url = response.imgUrl
                //    let quill = this.$refs.myQuillEditor.quill
                //    // 插入图片链接
                //    quill.insertEmbed(this.indexVideo, 'image', url)
                //    quill.setSelection(this.indexVideo + 1)
                //});

                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        // this.addLoading = false;
                        // //NProgress.done();
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "success"
                        //});
                        //this.IsShowZBTP = true;
                        //this.EditZBTP = res.data.response;
                        //this.EditZBTPUrl = global.EquipPictureDemain + res.data.response;
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;
                        // 插入图片链接
                        quill.insertEmbed(this.indexVideo, 'image', url);
                        quill.setSelection(this.indexVideo + 1);
                    } else {
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "error"
                        //});
                        //this.addLoading = false;
                    }
                });
            },
            //// 文件上传
            uploadFile(param) {
                // res为图片服务器返回的数据
                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;;
                        let fileNameLength = param.file.name.length
                        // 插入链接
                        let length = quill.getSelection().index;
                        // quill.insertEmbed(length, 'link', {href:res.data, innerText:file.name}, "api")
                        quill.insertEmbed(length, 'link', { href: url, innerText: param.file.name })
                        quill.setSelection(length + fileNameLength)

                    } else {
                    }
                });


                //// 获取富文本组件实例
                //let quill = this.$refs.myQuillEditor.quill;
                //// 如果上传成功
                //if (res.code === 200) {
                //    let fileNameLength = file.name.length
                //    // 插入链接
                //    let length = quill.getSelection().index;
                //    // quill.insertEmbed(length, 'link', {href:res.data, innerText:file.name}, "api")
                //    quill.insertEmbed(length, 'link', { href: res.data, innerText: file.name })
                //    quill.setSelection(length + fileNameLength)
                //} else {
                //    this.$message.error("插入失败");
                //}
                /*// loading动画消失*/
                this.quillUpdateImg = false;
            },


            handleChange(value) {
                console.log("value=" + value);
                this.IsShowUrl = true;
                //this.$refs.SelEquipCate.dropDownVisible = false;
                this.allUrl = [];
                if (value == 1 || value == "1") {
                    //获得所有商品
                    this.handleAllProducts();
                } else if (value == 2 || value == "2") {
                    //获得所有商品分类
                    this.handleAllProductTypes();
                } else if (value == 3 || value == "3") {
                    //获得所有文章
                    this.handleAllBlogArticle();
                } else {
                    this.IsShowUrl = false;
                }
                console.log(this.allUrl);
            },
            //获取所有商品分类
            handleAllProductTypes() {
                if (this.allProductTypes == null || this.allProductTypes.length <= 0) {
                    let para = {
                        key: ''
                    };
                    this.listLoading = true;
                    this.allProductTypes = [];
                    //NProgress.start();
                    getAllCoupon(para).then((res) => {
                        this.allProductTypes = res.data.response;
                        for (var i = 0; i < this.allProductTypes.length; i++) {
                            var item = {};
                            item.Name = this.allProductTypes[i].Name;
                            item.Value = this.allProductTypes[i].Id;
                            this.allUrl.push(item);
                        }
                        this.listLoading = false;
                    });
                } else {
                    for (var i = 0; i < this.allProductTypes.length; i++) {
                        var item = {};
                        item.Name = this.allProductTypes[i].Name;
                        item.Value = this.allProductTypes[i].Id;
                        this.allUrl.push(item);
                    }
                }
            },
            //获取所有商品
            handleAllProducts() {
                if (this.allProducts == null || this.allProducts.length <= 0) {
                    let para = {
                        key: ''
                    };
                    this.listLoading = true;
                    this.allProducts = [];
                    //NProgress.start();
                    getAllRecharge(para).then((res) => {
                        this.allProducts = res.data.response;

                        for (var i = 0; i < this.allProducts.length; i++) {
                            var item = {};
                            item.Name = this.allProducts[i].ProductName;
                            item.Value = this.allProducts[i].Id;
                            this.allUrl.push(item);
                        }

                        this.listLoading = false;
                    });
                } else {
                    for (var i = 0; i < this.allProducts.length; i++) {
                        var item = {};
                        item.Name = this.allProducts[i].ProductName;
                        item.Value = this.allProducts[i].Id;
                        this.allUrl.push(item);
                    }
                }
            },
            //获取所有商品分类
            handleAllBlogArticle() {
                if (this.allBlogArticle == null || this.allBlogArticle.length <= 0) {
                    let para = {
                        key: ''
                    };
                    this.listLoading = true;
                    this.allBlogArticle = [];
                    //NProgress.start();
                    getAllBlogArticle(para).then((res) => {
                        this.allBlogArticle = res.data.response;
                        for (var i = 0; i < this.allBlogArticle.length; i++) {
                            var item = {};
                            item.Name = this.allBlogArticle[i].btitle;
                            item.Value = this.allBlogArticle[i].bID;
                            this.allUrl.push(item);
                        }
                        this.listLoading = false;
                    });
                } else {
                    for (var i = 0; i < this.allBlogArticle.length; i++) {
                        var item = {};
                        item.Name = this.allBlogArticle[i].btitle;
                        item.Value = this.allBlogArticle[i].bID;
                        this.allUrl.push(item);
                    }
                }
            },

        },
        mounted() {
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);

            this.$nextTick(function () {
                //在页面渲染完成后
                this.tableHeight = window.innerHeight - this.$refs.table.$el.getBoundingClientRect().top - 50
                this.$refs.table.$el.getBoundingClientRect().top //表格距离浏览器的高度
                var that = this
                // 添加监听窗口大小变化事件
                window.onresize = function () {
                    that.tableHeight = window.innerHeight - that.$refs.table.$el.getBoundingClientRect().top - 50
                }
            })
        },
    };
</script>

<style scoped>
    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }

    /*// 视频上传组件*/
    .editerV /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px;
    }

    .editerVideo {
        width: 100%;
    }

    .editerVideo_title {
        display: flex;
        height: 30px;
        line-height: 30px;
        width: 100%;
        color: #1f2f3d;
        font-weight: bold;
        justify-content: flex-start;
        border-bottom: 2px solid #DCDFE6;
    }

    .editerVideo_title_act {
        color: #409eff;
        border-bottom: 2px solid #409eff;
        margin-bottom: -2px;
    }

    .editerVideo_title_item {
        margin-right: 10px;
    }

    .editerVideo_main {
        width: 100%;
        height: 120px;
    }

    .editerVideo_main_url {
        width: 100%;
        height: 200px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 35px;
    }

    .avatar-uploader_video {
        width: 100px;
        height: 100px;
        border: 1px solid #D9D9D9;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }

    .avatar-uploader-videoiocn {
        font-size: 28px;
        color: #D9D9D9;
        line-height: 90px;
        text-align: center;
    }

    .videoProgress {
        margin-top: 30px;
    }

    .quillWidthmain {
        width: 800px;
        height: 320px;
    }

    .quillWidth {
        width: 800px;
        height: 270px;
    }

    .ql-upload {
        background: url("./../../assets/upload.svg") !important;
        background-size: 20px 20px !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
    }
</style>
